export enum SortingValueEnum {
  ASC = 'ASC',
  DESC = 'DESC',
  MANUALLY = 'MANUALLY',
}
